<div class="letter-dashboard">
  <h1 class="title text-center">
   my completed letters
  </h1>
  <div class="percent-block" [ngbPopover]="'Your progress against today’s letter target'"  triggers="hover" >

    <div class="circle-placeholder">
      <div class="progress-wrapper">
            <circle-progress
              [percent]="100"
              [radius]="90"
              [outerStrokeWidth]="8"
              [outerStrokeColor]="'#eaeaea'"
              [innerStrokeWidth]="0"
              [animation]="false"
              [showTitle]="false"
              [showUnits]="false"
              [showSubtitle]="false"
              [showBackground]="false"
              [units]="''"        
              >
      
            </circle-progress>
          
            <circle-progress
              [percent]="letter.percent"
              [radius]="90"
              [outerStrokeWidth]="8"
              [outerStrokeColor]="'#FF6550'"
              [innerStrokeWidth]="0"
              [animation]="true"
              [animationDuration]="700"
              [title]="letter.percent + '%'"
              [titleFontSize]="37"
              [titleColor]="'#747474'"
              [units]="''"
              [unitsFontSize]="16"
              [unitsColor]="'#747474'"
              [showSubtitle]="false"
              [showBackground]="false"
              class="absolute-progress">
            </circle-progress>
          </div>
      <span class="sub-title">complete</span>
      <span class="range">{{letter.completed}} of {{letter.total}}</span>      
    </div>
</div>
    <!-- <div class="circle-placeholder">
      <img src="../../../../../assets/img/icons/circle-grey.svg" alt="percentage of letters complete" />
      <span class="sub-title">complete</span>
      <span class="range">{{letter.completed}} of {{letter.total}}</span>
    </div> -->
    <!-- <circle-progress [percent]="letter.percent"
                     [radius]="90"
                     [outerStrokeWidth]="8"
                     [innerStrokeWidth]="0"
                     [outerStrokeColor]="getCircleColor()"
                     [titleFontSize]="37"
                     [titleColor]="'#747474'"
                     [unitsColor]="'#747474'"
                     [subtitleColor]="'transparent'"
                     [unitsFontSize]="37"
                     [animation]="true"
                     [animationDuration]="700">
      </circle-progress> -->